module.exports = __webpack_public_path__ + "img/main-logo.e6793d6f.svg";